import objectFitVideos from 'object-fit-videos'

document.addEventListener('turbolinks:load', () => {
  objectFitVideos()
})
